// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "b5ecb63479aebdf89947da4c311a648d8b23a9ab/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};